import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import i18n from "i18n";

import Cookie from "js-cookie";
import Api from "utils/wApi/index";
import { BRANCH_LIST } from "utils/uiData";
import useCart from "store";

import Cart from "layout/cart";
import {
	Grid,
	Container,
	Typography,
	Box,
	Stack,
	Button,
	RadioGroup,
	Radio,
	FormControl,
	FormControlLabel,
} from "@mui/material";
import { Logo, CommonModal, SvgIconStyle } from "components";

import LogoIcon from "assets/icons/logo.svg";
import DefaultStandBy from "assets/image/default_standby.jpeg";
import SettingIcon from "assets/icons/setting.svg";
import GlobalIcon from "assets/icons/global.svg";
import ArrowIcon from "assets/icons/arrow-right.svg";

// ----------------------------------------------------------------------
// 대기화면 페이지
export default function HomePage() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const {
		festival,
		standByImg,

		setFestival,
		setStandByImg,
		setLanguage,
	} = useCart((state) => state);
	const [open, setOpen] = useState(false);

	// 언어 리스트
	const lgArr = [
		{ value: "koKr", label: "한국어" },
		{ value: "enUs", label: "English" },
		{ value: "jaJp", label: "日本語" },
		{ value: "zhCn", label: "中文 (简体)" },
		{ value: "zhTw", label: "中文 (繁體)" },
	];
	
	const handleLg = (e) => {
		i18n.changeLanguage(e.target.value);
		setLanguage(e.target.value);
	};

	const INIT = async () => {
		// 페스티벌 정보 조회
		const {
			data: { data: festivalData },
		} = await Api.getFestival();
		setFestival(festivalData);

		// ===== 키오스크 대기화면 =====
		try {
			const adCategory = `kiosk_standby_${festivalData.id}`;
			const { data: adStandBy } = await Api.ad(null, adCategory, {});

			setStandByImg(adStandBy.imageUrl);
		} catch (error) {}
	};
	useEffect(() => {
		if (!festival) INIT();
	}, []);

	return (
		<Box sx={{ position: "relative" }}>
			{/* 로고 | 세팅 */}
			<Box
				sx={{
					width: "100%",
					height: 150,
					display: "flex",
					alignItems: "top",
					justifyContent: "space-between",
					position: "absolute",
					top: 0,
					px: 6,
					pt: 4.5,
					background:
						"linear-gradient(to bottom, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0) 70%)",
				}}
			>
				<SvgIconStyle src={LogoIcon} sx={{ width: 120, color: "white" }} />

				<Box onClick={() => navigate("/admin/login")}>
					<SvgIconStyle src={SettingIcon} origin size={30} />
				</Box>
			</Box>

			<Box
				sx={{
					width: "100%",
					height: "calc(100vh - 160px)",
					background: `url(${
				standByImg === ""
							? DefaultStandBy
							: standByImg
					}) no-repeat center / cover`,
				}}
				onClick={() => navigate("/menus")}
			/>

			<Box
				sx={{
					height: 160,
					p: 3.75,
					display: "flex",
					gap: 3.75,
					bgcolor: "white",
				}}
			>
				<Button
					variant="contained"
					sx={{
						minWidth: 220,
						gap: 1,
						color: "black",
						bgcolor: "grey.400",
						"&:hover,&:active": { color: "black", bgcolor: "grey.400" },
					}}
					onClick={() => setOpen(true)}
				>
					<SvgIconStyle src={GlobalIcon} origin size={24} />
					<Typography variant="h4">language</Typography>
				</Button>
				<Button
					variant="contained"
					sx={{ width: "100%", gap: 2 }}
					onClick={() => navigate("/menus")}
				>
					<Typography variant="h2">{t("order-menu")}</Typography>
					<SvgIconStyle src={ArrowIcon} origin size={28} />
				</Button>
			</Box>

			{/* 언어변경 모달 */}
			<CommonModal
				width={450}
				open={open}
				onClose={() => setOpen(false)}
				footer={{
					label: t("check"),
					onClick: () => {
						Cookie.set("qs-kiosk-lg", "extended");
						setOpen(false);
					},
				}}
			>
				<Typography variant="h2" sx={{ textAlign: "center", py: 3 }}>
					Select Language
				</Typography>

				<FormControl>
					<RadioGroup
						value={i18n.language}
						sx={{
							display: "flex",
							flexDirection: "column",
							gap: 4,
							width: "100%",
							p: 4,
						}}
					>
						{lgArr.map((lg) => (
							<FormControlLabel
								key={lg.value}
								value={lg.value}
								label={<Typography variant="h4">{lg.label}</Typography>}
								control={
									<Radio
										sx={{
											"& svg": {
												color:
													i18n.language === lg.value ? "primary.main" : "black",
											},
										}}
										onChange={(e) => handleLg(e)}
									/>
								}
							/>
						))}
					</RadioGroup>
				</FormControl>
			</CommonModal>
			{/* 언어변경 모달 */}
		</Box>
	);
}
